// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "io.noone",
    name: "Noone Wallet",
    homepage: "https://noone.io/",
    image_id: "fbae89d3-d6cb-4b98-bd1c-b2007b61ed00",
    app: {
        browser: null,
        ios: "https://apps.apple.com/us/app/noone-wallet/id1668333995",
        android: "https://play.google.com/store/apps/details?id=io.noone.androidwallet&hl=en&gl=US",
        mac: null,
        windows: null,
        linux: null,
        chrome: "https://chrome.google.com/webstore/detail/noone-wallet/bgfhmafjampalkbjicjcjiikhlaggdnm",
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "<root>://",
        universal: null,
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map